import { Injectable } from '@angular/core';
import { Maybe } from '@orderna/admin-panel/src/types/maybe';
import { QueryOptions } from '@orderna/admin-panel/src/types/query-options';
import { Data } from '@orderna/admin-panel/src/utils/service';
import { BehaviorSubject } from 'rxjs';
import {
  IDayOfWeekSaleResponseDto,
  DayOfWeekSaleResponse,
} from '../../../../model/day-of-week-sale';
import { ISalesByDayOfWeekApiService } from './sales-by-day-of-week-api.interface';
import { FindSalesByDayOfWeekQueryDto } from './dtos/find-sales-by-day-of-week.query.dto';
import { FindSalesByDayOfWeekResponseDto } from './dtos/find-sales-by-day-of-week.response.dto';
import { HandleBlobHttpResponseOptions } from '@orderna/admin-panel/src/types/handle-blob-http-response-options';
import { ExportSalesByDayOfWeekQueryDto } from './dtos/export-sales-by-day-of-week.query.dto';

@Injectable({
  providedIn: 'root',
})
export class SalesByDayOfWeekMockApiService implements ISalesByDayOfWeekApiService {
  data = {
    day_of_week_sales: {
      items: [] as DayOfWeekSaleResponse[],
      queryOptions: {
        page: 1,
        size: 10,
      } as QueryOptions<IDayOfWeekSaleResponseDto>,
      subject: new BehaviorSubject<Maybe<DayOfWeekSaleResponse[]>>(null), // Change type here
      totalSubject: new BehaviorSubject<Maybe<number>>(null),
      totalAfterFilterSubject: new BehaviorSubject<Maybe<number>>(null),
    },
  };

  get dayOfWeekSalesData(): Data<
    DayOfWeekSaleResponse,
    IDayOfWeekSaleResponseDto
  > {
    return this.data['day_of_week_sales'];
  }

  findSalesByDayOfWeek(
    query: FindSalesByDayOfWeekQueryDto
  ): Promise<FindSalesByDayOfWeekResponseDto> {
    throw new Error('Method not implemented.');
  }
  exportSalesByDayOfWeek(query: ExportSalesByDayOfWeekQueryDto, options?: HandleBlobHttpResponseOptions): void {
    throw new Error('Method not implemented.');
  }
}
